import mixpanel from "mixpanel-browser"
import { User } from "../types/User"
import { isExcludedEmail } from "../utils/email"
import { isProduction } from "../utils/general"

export const updateMixpanelUser = (user: User) => {
  if (!isProduction || !user.uid) {
    return
  }
  // Identify must not depend on the email: guests get one only later, and
  // events tracked before identify land on a $device id that can never be
  // joined against the backend's Firebase uid.
  if (user.email && isExcludedEmail(user.email)) {
    return
  }

  mixpanel.identify(user.uid)

  if (user.email) {
    mixpanel.people.set({ $name: user.name, $email: user.email })
  }
}
